import { registerPlugin } from '@capacitor/core';


export interface TransactionResult {
  isAccepted: boolean;
  isFailed: boolean;
  transactionType: string;
  amount: string;
  tipAmount: string;
  taxAmount: string;
  transactionData: string;
  cardCircuit: string;
  cardPAN: string;
  merchantId: string;
  merchantReceipt: string;
  customerReceipt: string;
  terminalId: string;
  errorMessage?: string;
}

export interface ReconciliationResult {
  isAccepted: boolean;
  isFailed: boolean;
  terminalId: string;
  reconciliationData: string;
  merchantReceipt: string;
  customerReceipt: string;
  errorMessage?: string;
}

export interface UnexpectedErrorMessage {
  methodName: string;
  input: object;
  results: object;
}


interface SPaymentPOSPlugin {
  startSwitchMode: (data: {appId: string}) => Promise<{isAvailable: boolean}>;
  isAvailable: () => Promise<{isAvailable: boolean}>;
  startTransaction: (data: {amount: string; currency: string; transactionId: string}) => Promise<{transactionResult: TransactionResult}>;
  startRefundTransaction: (data: {amount: string; currency: string; transactionId: string}) => Promise<{transactionResult: TransactionResult}>;
  startReversalTransaction: (data: {amount: string; currency: string; transactionId: string; transactionData: string}) => Promise<{transactionResult: TransactionResult}>;
  startReconciliation: () => Promise<{reconciliationResult: ReconciliationResult}>;
}

const SPaymentPOS = registerPlugin<SPaymentPOSPlugin>('SPaymentPOS');

export default SPaymentPOS;
